import { Modal, ModalBody, ModalFooter, Button } from '@spotoninc/nexus-react';
import NexusFilterDropdown from '../../../common/NexusFilterDropdown';
import styles from './mobileFiltersModal.module.css';
import { PRIORITY, STATUS, TASK_TYPE } from './useImprovedTaskManager';
import { memo } from 'react';
import { Flex } from '@chakra-ui/react';

/**
 * MobileFiltersModal component for mobile filter selection
 * Only visible on mobile devices
 *
 * @param {boolean} isOpen - Controls modal visibility
 * @param {function} onClose - Called when modal is closed
 * @param {function} onDone - Called when Done button is clicked
 * @param {object} filters - Current filter values
 * @param {function} handleUpdateFilter - Function to update filters
 * @param {array} locationData - Location options
 * @param {array} userOptions - User options
 * @param {array} PRIORITY - Priority options
 * @param {array} STATUS - Status options
 * @param {array} TASK_TYPE - Task type options
 */
function MobileFiltersModal({
  isOpen,
  onClose,
  onDone,
  filters,
  handleUpdateFilter,
  locationData,
  userOptions,
}) {
  const handleDone = () => {
    if (onDone) {
      onDone();
    }
    onClose();
  };

  return (
    <div className={styles.mobileOnly}>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Filters"
        data-testid="mobile-filters-modal"
      >
        <ModalBody className={styles.modalBody}>
          <Flex direction={'column'} gap={4} className={styles.modalWrapper}>
            <NexusFilterDropdown
              label="Location"
              options={locationData}
              onChange={handleUpdateFilter('location')}
              value={
                filters['location']
                  ? Array.isArray(filters['location'])
                    ? filters['location']
                    : [filters['location']]
                  : undefined
              }
            />
            <NexusFilterDropdown
              label="Assigned To"
              options={userOptions}
              onChange={handleUpdateFilter('assigned_to')}
              value={
                filters['assigned_to']
                  ? Array.isArray(filters['assigned_to'])
                    ? filters['assigned_to']
                    : [filters['assigned_to']]
                  : undefined
              }
            />
            <NexusFilterDropdown
              label="Priority"
              options={PRIORITY}
              onChange={handleUpdateFilter('priority')}
              value={
                filters['priority']
                  ? Array.isArray(filters['priority'])
                    ? filters['priority']
                    : [filters['priority']]
                  : undefined
              }
            />
            <NexusFilterDropdown
              label="Status"
              options={STATUS}
              onChange={handleUpdateFilter('status')}
              value={
                filters['status']
                  ? Array.isArray(filters['status'])
                    ? filters['status']
                    : [filters['status']]
                  : undefined
              }
            />
            <NexusFilterDropdown
              label="Type"
              options={TASK_TYPE}
              onChange={handleUpdateFilter('task_type')}
              value={
                filters['task_type']
                  ? Array.isArray(filters['task_type'])
                    ? filters['task_type']
                    : [filters['task_type']]
                  : undefined
              }
            />
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={handleDone}
            variant="filled"
            data-testid="filters-done-button"
          >
            Done
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default memo(MobileFiltersModal);
